var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("label", { staticClass: "d-block" }, [
        _vm._v("Mögliche Dateianhänge"),
      ]),
      _vm._v(" "),
      _c("b-table", {
        ref: "documentTable",
        attrs: { fields: _vm.attachmentFields, items: _vm.preparedAttachments },
        scopedSlots: _vm._u([
          {
            key: "cell(selected)",
            fn: function (rowData) {
              return [
                _c("b-form-checkbox", {
                  attrs: {
                    checked: rowData.item.checked,
                    value: rowData.item.name,
                  },
                  on: {
                    change: (checked) =>
                      _vm.handleCheckboxChange(rowData, checked),
                  },
                }),
              ]
            },
          },
          {
            key: "cell(label)",
            fn: function (rowData) {
              return [
                rowData.item.fileId !== null
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getLinkForFile(rowData.item.fileId),
                          target: "_blank",
                          title: "Vorschau",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(rowData.item.label) +
                            "\n            "
                        ),
                      ]
                    )
                  : _c("span", [
                      _vm._v(
                        "\n                " +
                          _vm._s(rowData.item.label) +
                          "\n            "
                      ),
                    ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }